
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ModalWindow from '@/components/molecules/ModalWindow.vue'
import LabelBase from '@/components/atoms/LabelBase.vue'
import InputText from '@/components/molecules/InputText.vue'
import ButtonSubmit from '@/components/molecules/ButtonSubmit.vue'

/**
 * 生徒メールアドレス編集モーダルのフォーマット
 */
@Component({
  components: {
    ModalWindow,
    LabelBase,
    InputText,
    ButtonSubmit,
  },
})
export default class ModalStudentMailAddress extends Vue {
  /** モーダル分子 */
  @Ref()
  modalWindow!: ModalWindow

  /** 確認ボタン押下時のイベント */
  @Prop()
  private eventSubmit!: () => void

  /** メールアドレス */
  public mailAddress: string = ''

  /**
   * モーダルを開く
   */
  public show(): void {
    // メールアドレスをクリア
    this.mailAddress = ''

    this.modalWindow.show()
  }

  /**
   * モーダルを閉じる
   */
  public hide(): void {
    this.modalWindow.hide()
  }
}
